import { enums, object, optional } from 'superstruct';
import { stringDate } from '@arc/shared/util-superstruct';
const CLEANUP_STATUSES = ['QUEUED', 'ERROR'];
export const EditCleanupTaskDto = object({
  status: optional(enums(CLEANUP_STATUSES)),
  deleteAt: optional(stringDate())
});